import { useState, useEffect } from "react";
import * as Comp from "../../../Common/CommonComponents";

const PDepartment = (props) => {
  const [tableData, setTableData] = useState([]);
  const [writeAuthority, setWriteAuthority] = useState(false);

  useEffect(() => {
    if (props.data !== undefined) {
      setTableData(props.data);
    }
    if (props.actionPermission !== undefined) {
      setWriteAuthority(props.actionPermission.WRITE === "Y");
    }
  }, [props.data]);

  function checkBoxHandler(row, val) {
    const newData = [...tableData];
    const currentRow = newData[row.rowNo];

    try {
      props.ChangeDepartmentPermission(currentRow.DEPT_ID, val);
      currentRow.AUTHORIZED = val ? "Y" : "N";
    } finally {
      setTableData([...newData]);
    }
  }

  //#region Table Columns
  const columns = [
    {
      accessorKey: "DEPT_NAME",
      header: "Feature",
      size: 200,
    },
    {
      id: "FEATURE_TYPE",
      header: "",
      size: 60,
      accessorFn: (row) => {
        return (
          <>
            <Comp.Input
              id={`${row.DEPT_NAME}_FEATURE_TYPE`}
              name="WRITE"
              type="checkbox"
              className=""
              disabled={!writeAuthority}
              checked={row.AUTHORIZED === "Y"}
              onChange={(e) => checkBoxHandler(row, e.target.checked)}
            />
          </>
        );
      },
    },
  ];
  //#endregion

  return (
    <>
      <Comp.VirtualTable
        columns={columns}
        data={tableData}
        enableRowSelection={false}
      />
    </>
  );
};

export default PDepartment;
